import { render, staticRenderFns } from "./AIEstheDetectFacePlanPage.vue?vue&type=template&id=caa07ea4&scoped=true&"
import script from "./AIEstheDetectFacePlanPage.vue?vue&type=script&lang=ts&"
export * from "./AIEstheDetectFacePlanPage.vue?vue&type=script&lang=ts&"
import style0 from "./AIEstheDetectFacePlanPage.vue?vue&type=style&index=0&id=caa07ea4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa07ea4",
  null
  
)

export default component.exports